<template lang="pug">
.room-multiple-register-example-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc hide-footer scrollable)
    .room-multiple-register-example-modal-header(slot="modal-header" slot-scope="{ cancel }")
      .float-left.title
        span 部屋情報一括登録のCSVファイルの仕様と作成例
      .float-right
        button(type="button" class="close" @click="cancel()") ×
    .room-multiple-register-example-modal-body
      span.title CSVファイル仕様
      ul
        li
          span カンマ（,）区切りのCSVファイル。文字コードはSJISもしくはUTF-8。
        li
          span 1行目の1列目に「SERVICE_ROOM_INFO」と記載してください。
        li
          span 2行目に項目名、3行目以降に部屋登録情報を記載してください。
      span.title CSVファイルの項目名
      .room-multiple-register-example-modal-table
        .thead
          .header-line
            .th.item-name 項目名
            .th.item-description 説明
            .th.item-required 必須
            .th.item-remarks 備考
        .tbody
          .body-line
            .td.item-name name
            .td.item-description 部屋名
            .td.item-required.justify-content-center.font-strong-color 必須
            .td.item-remarks 最大32文字。登録されている部屋名のみ有効。
          .body-line
            .td.item-name use_type
            .td.item-description 部屋用途
            .td.item-required.justify-content-center.font-strong-color 必須
            .td.item-remarks 「空床管理対象外」「入居用部屋」「ショートステイ」のいずれかを入力。
          .body-line
            .td.item-name room_type
            .td.item-description 部屋種別
            .td.item-required.justify-content-center.font-strong-color 必須
            .td.item-remarks 「空床管理対象外」「個室」「２人部屋（夫婦部屋）」「多床室（男性）」「多床室（女性）」のいずれかを入力。
          .body-line
            .td.item-name capacity
            .td.item-description 部屋定員
            .td.item-required.justify-content-center 任意
            .td.item-remarks 半角数字のみ。部屋種別が「多床室（男性）」「多床室（女性）」の場合のみ必須。
          .body-line
            .td.item-name group_name
            .td.item-description 利用者グループ名
            .td.item-required.justify-content-center 任意
            .td.item-remarks 登録済みの利用者グループ名を記載してください。未記載の場合は「無所属」で登録します。
    .room-multiple-register-example-modal-body
      span.title CSVファイルの作成例
      .room-multiple-register-example-modal-example-table
        .tbody
          .body-line
            .td.file-name SERVICE_ROOM_INFO
          .body-line
            .td.name name
            .td.use-type use_type
            .td.room-type room_type
            .td.capacity capacity
            .td.group-name group_name
          .body-line
            .td.name 101号室
            .td.use-type 入居用部屋
            .td.room-type 個室
            .td.capacity 
            .td.group-name 東棟１階
          .body-line
            .td.name 201号室
            .td.use-type ショートステイ
            .td.room-type 多床室（女性）
            .td.capacity 4
            .td.group-name 
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 部屋情報一括登録のCSVファイルの作成例モーダル
 */
@Component
export default class RoomMultipleRegisterExampleModal extends Vue {
  @Prop({
    required: true
  })
  value!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>
